import GenerateManualCertificateModal from './GenerateManualCertificateModal';

export default GenerateManualCertificateModal;
